export let _floatConverter = (value, floatPoint) => {
  return parseFloat(parseFloat(value).toFixed(floatPoint ?? 3));
};
